import Link from 'next/link';
import { useState } from 'react';
import { Layout, CtaForm, SignupForm } from '../../components';
import {
	createReportFault,
	createServiceRequest,
	bookHotdesks,
	bookFacilities,
	inviteVisitors,
	slackGuide,
} from '../../utils/images';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';

const SLACK_GUIDES = {
	createReportFault: {
		content: 'Make fault reports to your facility manager',
		src: createReportFault,
		helpLink: 'https://blog.facilitybot.co/blog/knowledge-base/slack/making-fault-reports-through-slack/',
	},
	createServiceRequest: {
		content: 'Make service requests to your facility manager',
		src: createServiceRequest,
		helpLink: 'https://blog.facilitybot.co/blog/knowledge-base/slack/making-a-service-request-through-slack/',
	},
	bookFacilities: {
		content: 'Book rooms and other common facilities',
		src: bookFacilities,
		helpLink:
			'https://blog.facilitybot.co/blog/knowledge-base/slack/making-room-or-common-facilities-bookings-through-slack/',
	},
	bookHotdesks: {
		content: 'Book hotdesks',
		src: bookHotdesks,
		helpLink: 'https://blog.facilitybot.co/blog/knowledge-base/slack/making-desks-bookings-through-slack/',
	},
	inviteVisitors: {
		content: 'Invite Visitors',
		src: inviteVisitors,
		helpLink: 'https://blog.facilitybot.co/blog/knowledge-base/slack/inviting-visitors-through-slack/',
	},
};

export default function AddToSlack() {
	const [showingGuide, setShowingGuide] = useState(SLACK_GUIDES.createReportFault);

	return (
		<Layout pageName="Add to Slack">
			<div className="resource-page resource-page--slack">
				<section className="heading">
					<div className="container">
						<h1 className="heading__title">Add to Slack</h1>
						<div className="heading__content">
							<h2 className="heading__desc">
								Allow your building users to experience FacilityBot directly through Slack
							</h2>
							<button className="btn btn--help">
								<a
									href="https://blog.facilitybot.co/blog/knowledge-base/slack/how-requestors-can-find-the-correct-slack-channel-by-searching-for-the-bot-name-or-scanning-a-qr-code/"
									target="_blank"
									rel="noopener noreferrer"
								>
									Help
								</a>
							</button>
						</div>
					</div>
				</section>

				<section className="illustration">
					<div className="container">
						<div className="illustration__wrapper">
							<div className="illustration__img-wrapper">
								<Zoom>
									<img src={showingGuide.src} alt="Illustrate Bot Actions" className="illustration__img" width={1200} />
								</Zoom>
							</div>

							<ul className="illustration__list">
								{Object.values(SLACK_GUIDES).map((guide, index) => (
									<li key={index} className="illustration__item" onClick={(e) => setShowingGuide(guide)}>
										<div className="item__content">
											<span className={`item__text ${showingGuide === guide ? 'active' : ''}`}>{guide.content}</span>
											<button className="btn btn--help">
												<Link href={guide.helpLink} legacyBehavior>
													<a target="_blank" rel="noopener noreferrer">
														Help
													</a>
												</Link>
											</button>
										</div>
									</li>
								))}
							</ul>
						</div>
					</div>
				</section>

				<section className="trial-cta">
					<div className="container">
						<div className="trial-cta__wrapper">
							<SignupForm btnText="sign up for a 14-day free trial" btnClass="btn btn--cta" type={{ name: 'trial' }} />
							<div className="trial-cta__condition">no credit card required</div>
						</div>
					</div>
				</section>

				<section className="guide">
					<div className="container">
						<div className="guide__wrapper">
							<div className="guide__title">
								Navigate to Integrations -{'>'} Slack and click the "Add to Slack" button
							</div>
							<img src={slackGuide} alt="Slack Guide" className="guide__img" />
						</div>
					</div>
				</section>

				<CtaForm />
			</div>
		</Layout>
	);
}
